(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-template"]) return;
  try {
    

  // Alerta para que el producto mioMat solo pueda ser vendido si está solo en el carrito
  const mioMat = document.getElementById('produto-Miomat');
  
  if(mioMat){
    const checkoutButton = document.getElementById('cart-checkout');
    checkoutButton.disabled = true;
    console.log('Hay miomat', checkoutButton); 
  }
  // END Alerta para que el producto mioMat solo pueda ser vendido si está solo en el carrito

  } catch(e) { console.error(e); }
})();
})();
